import React from 'react';
// import UGHorizontalWidgetMinimalResponsive from './components/Widgets/UGHorizontalWidgetMinimalResponsive';
import {Box} from '@mui/material';
import UGHorizontalWidgetMinimalResponsive from './components/Widgets/UGHorizontalWidgetMinimalResponsive';


const App = () => <Box>
  <UGHorizontalWidgetMinimalResponsive/>
</Box>;

export default App;
